module.exports = __webpack_public_path__ + "static/media/dnata.add7cd99.png";